// Lib Imports
import React from 'react';
// import PropTypes from 'prop-types';
import { Box, Heading } from 'grommet';
import { useHistory } from 'react-router-dom';
import useQuery from 'granite-admin/utils/useQuery';
import useEmitter from 'granite-admin/utils/useEmitter';
import { useToast } from 'granite-admin/core/components/Toast';
import SplitLayout from 'granite-admin/core/components/SplitLayout';
import ResetPasswordForm from 'granite-admin/pages/forgotpassword/components/ResetPasswordForm';
import { setPasswordClicked } from 'granite-admin/accounts/controllers/user';
import { RESET_EVENTS } from 'granite-admin/accounts/controllers/constants';
import RESET_MESSAGES from 'granite-admin/messages/forgotPassword';
const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
const WelcomeUser = () => {
  const {
    successToast,
    errorToast
  } = useToast();
  const {
    query
  } = useQuery();
  const history = useHistory();
  const eventEmitter = useEmitter(event => {
    // console.log('EVENT FIRED---', event)
    switch (event.type) {
      case RESET_EVENTS.RESET_PASSWORD_SUCCESS:
        successToast(RESET_EVENTS.RESET_PASSWORD_SUCCESS);
        history.push('/login');
        break;
      case RESET_EVENTS.RESET_PASSWORD_FAILURE:
        errorToast(RESET_MESSAGES.RESET_PASSWORD_FAILURE);
        break;
      default:
        break;
    }
  });
  const resetPasswordFormOnSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      await setPasswordClicked(eventEmitter, {
        ...values,
        jwt_token: query.token
      });
    } catch (e) {
      if (e.errors) setErrors(e.errors);
    }
    setSubmitting(false);
  };
  return /*#__PURE__*/React.createElement(SplitLayout, {
    mainContent: /*#__PURE__*/React.createElement(Box, {
      width: "large"
    }, /*#__PURE__*/React.createElement(Heading, {
      level: 3
    }, "Welcome to ", projectName), /*#__PURE__*/React.createElement(Heading, {
      color: "dark-2",
      level: 5,
      size: "large"
    }, "Please activate your account and setup your password"), /*#__PURE__*/React.createElement(ResetPasswordForm, {
      onSubmit: resetPasswordFormOnSubmit
    }))
  });
};
WelcomeUser.propTypes = {
  // add your proptypes here
};
export default WelcomeUser;